import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const {
	LIGHT_GREY,
	GREY,
	FONT_COLOR,
	WHITE,
	PURPLE,
	BLACK,
	HOVER_GRAY_SHADE,
	DARK_PURPLE,
	TOGGLE_ACTIVE,
	LIGHT_GRAY_SHADE
} = colors;
import { Bogle_Regular, Space_Between } from 'constants/constant';

const shareReportStyles = makeStyles(() => ({
	drawerContainer: {
		width: '360px',
		marginBottom: '160px'
	},
	drawerContent: {
		padding: '16px'
	},
	drawerContentWithoutPadding: {
		paddingBottom: '0px'
	},
	darwer: {
		width: '328px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: Space_Between
	},
	smallScreen: {
		width: '328px',
		display: 'flex',
		alignItems: 'center'
	},
	backIcon: {
		marginLeft: '-8px',
		marginRight: '8px'
	},
	drawerTitle: {
		fontSize: '24px',
		fontFamily: Bogle_Regular,
		color: BLACK,
		display: 'inline'
	},
	autoComplete: {
		fontSize: '14px',
		color: GREY
	},
	userNameLabel: {
		fontSize: '14px',
		lineHeight: '20px',
		color: FONT_COLOR,
		fontFamily: `${Bogle_Regular} !important`
	},
	userLoginIdLabel: {
		fontSize: '10px',
		lineHeight: '16px',
		color: FONT_COLOR,
		fontFamily: `${Bogle_Regular} !important`
	},
	text: {
		fontFamily: Bogle_Regular,
		color: FONT_COLOR,
		fontSize: '14px',
		minHeight: '112px'
	},
	deleteReport: {
		fontSize: '14px',
		paddingLeft: '16px',
		lineHeight: '24px',
		color: GREY,
		backgroundColor: HOVER_GRAY_SHADE
	},
	includeDataContainer: {
		position: 'fixed',
		bottom: '120px',
		width: '360px',
		display: 'flex',
		alignItems: 'center'
	},
	buttonContainer: {
		maxHeight: '88px',
		height: 'auto',
		textAlign: 'center',
		padding: '16px',
		borderTop: `1px solid ${LIGHT_GRAY_SHADE}`,
		position: 'fixed',
		bottom: 0,
		zIndex: 999,
		width: '336px',
		background: WHITE
	},
	drawerButton: {
		textTransform: 'unset',
		fontSize: '16px',
		fontWeight: 600,
		fontFamily: Bogle_Regular,
		border: '1px solid',
		width: '328px',
		height: '40px',
		'&:hover': {
			background: DARK_PURPLE,
			color: WHITE
		},
		'&:disabled': {
			color: WHITE,
			backgroundColor: LIGHT_GREY
		},
		borderRadius: '20px'
	},
	downloadButton: {
		color: WHITE,
		background: PURPLE,
		marginBottom: '8px'
	},
	errorContainer: { fontSize: '14px' },
	errorIcon: {
		'&.MuiListItemIcon-root': {
			minWidth: '24px'
		},
		'&.MuiSvgIcon-root': {
			innerHeight: '14px'
		}
	},
	hideBox: {
		display: 'none'
	},
	tabsIndicator: {
		height: 4,
		borderRadius: [[10, 10, 0, 0]]
	},
	'MuiTabs-flexContainer': {
		alignItems: 'center'
	},
	tabsRoot: {
		borderBottom: `1px solid #E3E4E5`,
		minHeight: 37
	},
	tabRoot: {
		color: BLACK,
		textTransform: 'capitalize !important',
		minHeight: 22,
		fontFamily: 'Bogle-Regular !important',
		fontSize: '12px !important',
		height: '100% !important',
		fontWeight: 500,
		display: 'content',
		minWidth: '80px',
		'&.Mui-selected': {
			fontWeight: 700,
			'& .userCount': {
				background: TOGGLE_ACTIVE,
				color: PURPLE
			}
		},
		'& .userCount': {
			background: LIGHT_GRAY_SHADE,
			borderRadius: '8px',
			padding: '0px 3px',
			fontSize: '10px',
			textAlign: 'center',
			alignItems: 'center',
			display: 'flex',
			height: '14px',
			marginLeft: '4px',
			color: GREY
		}
	},
	tabContainer: {
		boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
		borderRadius: '8px',
		textAlign: 'center'
	},
	userListItem: {
		'&:hover': {
			background: LIGHT_GRAY_SHADE
		}
	},
	userListItemLast: {
		borderBottomRightRadius: '8px',
		borderBottomLeftRadius: '8px'
	},
	inviteesDrawerContent: {
		height: '225px',
		overflowY: 'scroll'
	},
	tooltip: {
		width: '204px'
	}
}));

export default shareReportStyles;
